import {
  SET_PATIENTS,
  SET_CURRENT_PATIENT,
  SET_PATIENT_DEVICES,
  SET_PATIENT_COUNT,
  SET_CURRENT_PATIENT_PAUSE_STATE,
} from '../../constants';

const initialState = {
  patientsList: [],
  currentPatient: null,
  currentPatientDevices: [null, null],
  currentPatientPauseState: null,
  patientCount: 0,
};

const patientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PATIENTS:
      return { ...state, patientsList: action.patients };
    case SET_CURRENT_PATIENT:
      return { ...state, currentPatient: action.patient };
    case SET_PATIENT_DEVICES:
      return { ...state, currentPatientDevices: action.patientDevices };
    case SET_PATIENT_COUNT:
      return { ...state, patientCount: action.patientCount };
    case SET_CURRENT_PATIENT_PAUSE_STATE:
      return { ...state, currentPatientPauseState: action.paused };
    default:
      return state;
  }
};

export default patientsReducer;
